//#region Import
import { useState } from "react";

//Vapor Components
import VaporTag from "@vapor/react-custom/VaporTag";
import Stack from "@vapor/react-material/Stack";
import IconButton from "@vapor/react-material/IconButton";
import { DataGridPro, GridToolbar, itIT } from "@mui/x-data-grid-pro";

//Icons
import { ArrowForward as DetailIcon, DeleteOutlineOutlined as DeleteIcon } from "@mui/icons-material";

//Custom styles
import {
    chipGreen,
    chipRed,
} from "../../businessLogic/styles";

//Custom components
import { NoData } from "../../components/NoData";
import { ModalDelete } from "../../components/ModalDelete";
import { NotAuth } from "../../components/NotAuth";
//#endregion

export const AnagraficheOrfane = ({anagrafiche, onDetailClick, onDeleteAnagrafica, onBulkDeleteAnagrafiche, permissions, selectedRows = [], onSelectionChange}) => {    
    //#region UseStates
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [anagraficaToDelete, setAnagraficaToDelete] = useState(null);
    //#endregion
    //#region DataGrid Columns
    const [columns] = useState([
        { field: "id", headerName: "Id", type: "number", visible: false }, 
        {
            field: "cf",
            headerName: "Codice Fiscale",
            flex: 0.1,
            editable: false,
            filterable: true,
            visible: true,
        },
        { 
            field: "pIva", 
            headerName: "P. Iva", 
            flex: 0.1, 
            editable: false,
            filterable: true, 
            visible: true 
        },
        {
            field: "denominazione",
            headerName: "Denominazione",
            flex: 0.2,
            editable: false,
            filterable: true,
            visible: true,
        },
        {
            field: "isPg",
            headerName: "Tipo soggetto",
            flex: 0.1,
            editable: false,
            valueFormatter: (params) => {
                if (params.value == null) {
                    return "";
                }
                switch (params.value) {
                    case true:
                        return "Persona giuridica"
                    case false:
                        return "Persona fisica"
                    default:
                        return "N/A"
                }
            },
            visible: true
        },            
        { 
            field: "isPep", 
            headerName: "P.P.E.", 
            flex: 0.05, 
            editable: false,
            filterable: true,
            visible: true,
            renderCell : (params) => params.value ? <VaporTag variant="standard" label="Sì" sx={chipGreen} /> : <VaporTag variant="standard" label="No" sx={chipRed} />
        },
        {
            field: "identifiedOn",
            headerName: "Data identificazione",
            type: "date",
            flex: 0.1,
            editable: false,
            filterable: true,
            visible: true,
            valueFormatter: (params) => {
                if (params.value == null) {
                    return "";
                }
                return new Date(params.value).toLocaleDateString();
            },
        },
        {
            field: "actions",
            headerName: "",
            flex: 0.05,
            filterable: false,
            sortable: false,
            renderCell: (params) => renderDetailsButton(params.row),
        },
    ]);
    //#endregion    

    const renderDetailsButton = (item) => {
        if (item.id !== undefined) {
            return (
                <Stack direction="row" spacing={0}>  
                {permissions.canDelete && 
                    <IconButton 
                        color="error" 
                        onClick={(e) => handleDeleteClick(e, item)}
                    >
                        <DeleteIcon />
                    </IconButton>
                }                
                {permissions.canRead && 
                    <IconButton 
                        color="primary" 
                        onClick={(e) => handleGridBtnDetailClick(e, item)}
                    >
                        <DetailIcon />
                    </IconButton>
                }
                </Stack>
            );
        } else {
            return null;
        }
    };
    //#endregion

    //#region Handlers
    const handleGridBtnDetailClick = (event, item) => {
        event.stopPropagation();
        if (onDetailClick) {
            onDetailClick(item);
        }
    };

    const handleDeleteClick = (event, item) => {
        event.stopPropagation();
        setAnagraficaToDelete(item);
        setShowModalDelete(true);
    };

    const handleCloseModalDelete = () => {
        setShowModalDelete(false);
        setAnagraficaToDelete(null);
    };

    const handleConfirmDelete = async () => {
        if (anagraficaToDelete && onDeleteAnagrafica) {
            await onDeleteAnagrafica(anagraficaToDelete.id);
            handleCloseModalDelete();
        }
    };

    //#endregion

    return (
        <>
            <ModalDelete
                show={showModalDelete}
                strongDelete={false}
                deleteMessage={`Sei sicuro di voler eliminare l'anagrafica "${anagraficaToDelete?.denominazione || ''}"?`}
                onClose={handleCloseModalDelete}
                onOk={handleConfirmDelete}
            />

            {permissions.canRead ? (
                anagrafiche && anagrafiche.length > 0 ? (
                    <>
                    <DataGridPro
                        rows={anagrafiche}
                        columns={columns}
                        autoHeight={true}
                        slots={{ toolbar: GridToolbar }}
                        pageSizeOptions={[25, 50, 100]}
                        localeText={
                            itIT.components.MuiDataGrid.defaultProps.localeText
                        }
                        pagination
                        checkboxSelection
                        disableRowSelectionOnClick
                        rowSelectionModel={selectedRows}
                        onRowSelectionModelChange={(ids) => onSelectionChange && onSelectionChange(ids)}
                        onRowClick={(item, e) =>
                            handleGridBtnDetailClick(e, item.row)
                        }
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    id: false,
                                },                        
                            },
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                }
                            },
                        }}                    
                        slotProps={{
                            toolbar: { printOptions: { disableToolbarButton: true } },
                        }}
                    />
                    </>
                ) : (
                    <NoData size="small" />
                )
            ) : <NotAuth/>}
        </>
    )
}
